/* Mausrad und Trackpad in den 2D-Ansichten: Zwei-Finger-Scrollen am Mac-Trackpad verschiebt, Pinch (Strg+Rad) und Mausrad zoomen. Ohne DOM. */

export interface WheelLike { deltaX: number; deltaY: number; deltaMode: number; ctrlKey: boolean; wheelDeltaY?: number }

/** Sieht das Ereignis nach einem Trackpad aus? Mausrad-Rasten liefern ganze Vielfache von 120 (WebKit/Blink) bzw. Zeilen-Deltas (Firefox). */
export function isTrackpadWheel(e: WheelLike): boolean {
  if (e.deltaMode !== 0) return false;
  if (e.deltaX !== 0) return true;
  if (typeof e.wheelDeltaY === 'number') return e.wheelDeltaY % 120 !== 0;
  return !Number.isInteger(e.deltaY) || Math.abs(e.deltaY) < 50;
}

/** 'pan': Ansicht verschieben (nur am Mac, nicht bei Pinch = ctrlKey); sonst 'zoom' */
export function wheelAction(e: WheelLike, mac: boolean): 'pan' | 'zoom' {
  return mac && !e.ctrlKey && isTrackpadWheel(e) ? 'pan' : 'zoom';
}

/** Zoomfaktor für ein Zoom-Ereignis: Pinch (ctrlKey) liefert kleine Deltas und bekommt einen größeren Beiwert */
export function zoomFactor(e: WheelLike): number {
  const dy = e.deltaY * (e.deltaMode === 1 ? 33 : 1);
  return Math.pow(e.ctrlKey ? 1.01 : 1.0018, -dy);
}
